module.exports = __webpack_public_path__ + "sg.svg?76233054b485075671cad0576eb3e0d3";